import './styles/StatusBadge.css';

type BadgeVariant = 'active' | 'ended' | 'scheduled' | 'draft';

const StatusBadge: React.FC<{ status: BadgeVariant }> = ({ status }) => (
  <span className={`status-badge status-badge--${status}`}>
    {status.charAt(0).toUpperCase() + status.slice(1)}
  </span>
);

export default StatusBadge;
